import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { User, Lock, History, CloudDownload, UserRoundX, ChevronRight } from 'lucide-react';

const AccountPage = () => {
    const navigate = useNavigate();
    const { User_profile } = useSelector((state) => state.AccountProfile);

    const yourAccountNavigation = [
        { name: "Personal Details", icon: User, path: "/settings/account/details" },
        { name: "Password", icon: Lock, path: "/settings/account/pass" },
        { name: "Session History", icon: History, path: "/settings/account/session-history" },
        { name: "Profile Data", icon: CloudDownload, path: "/settings/account/profile-data" },
        { name: "Delete Your Account", icon: UserRoundX, path: "/settings/account/delete" },
    ];

    return (
        <div className="bg-white dark:bg-[#1E1D21]">
            <div className="sticky top-0 z-50">
                <div className="relative flex items-center justify-center h-12 bg-[#BDE6FF] rounded-b-xl px-2">
                    <IoMdArrowBack
                        onClick={() => navigate("/account/settings")}
                        className="absolute left-2 top-1/2 transition-transform -translate-y-1/2 text-[24px] text-black cursor-pointer"
                    />
                    <p className="text-center font-bold text-[16px] text-black flex-grow">Account Settings</p>
                </div>
            </div>

            <p className="text-[14px] text-black dark:text-white px-3 pt-5 font-bold">{User_profile?.full_name}</p>

            <div className="mx-3 bg-[#BDE6FF] dark:bg-[#333333] rounded-lg mt-2">
                {yourAccountNavigation.map((item, index) => (
                    <div 
                        key={index} 
                        onClick={() => navigate(item.path)}
                        className="flex items-center justify-between space-x-3 p-4 border-b border-gray-200 dark:border-gray-800/50 last:border-b-0"
                    >
                        <div className="flex items-center space-x-3">
                            <item.icon className="w-4 h-4 text-black dark:text-white" />
                            <span className="text-[14px] text-black dark:text-white">{item.name}</span>
                        </div>
                        <ChevronRight className="w-4 h-4 cursor-pointer text-black dark:text-white" />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default AccountPage